import React from 'react';
import { TableBlock } from '@/types/ui-blocks';
import { TableWrapper } from '@strivelabs/ui-blocks';

export interface TableBlockRendererProps {
  block: TableBlock;
}

/**
 * Renders a table block in the chat interface
 *
 * Passes all table configuration from the block content to the TableWrapper component,
 * which handles the table rendering and expand-to-dialog functionality.
 */
export function TableBlockRenderer({ block: { content } }: TableBlockRendererProps) {
  return (
    <TableWrapper
      headers={content.headers}
      rows={content.rows}
      title={content.title}
      description={content.description}
      variant={content.variant ?? 'default'}
      enableExport={content.enableExport ?? true}
      exportFilename={content.exportFilename ?? 'table-data'}
      wrapperClassName={content.className}
      expandable={true}
      expandedMaxHeight="70vh"
      cellMaxWidth="240px"
    />
  );
}
